import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';

import { withRouter } from '../../../util/withRouter';

import '../createDashboard.scss';

export function BackButton({ dashboards, location, router }) {
  if (!dashboards) {
    return null;
  }
  const handleClick = () => (location.key === 'default' ? router.push('/') : router.goBack());
  return (
    <div className="create_back">
      <Button variant="secondary" className="btn-mw-180" onClick={handleClick}>
        Back
      </Button>
    </div>
  );
}

BackButton.propTypes = {
  dashboards: PropTypes.number,
  location: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired
};

export const mapStateToProps = state => ({
  dashboards: state.dashboards.loaded ? state.dashboards.list.length : state.auth.user.dashboards,
});

export default withRouter(connect(mapStateToProps)(BackButton));
